import type { FundraisingResponse } from '@shared/schemas';

import {
  type FundraisingDraft,
  makeEmptyDraft,
  type SaveStatus,
  type ValidationErrors,
} from '../../_shared/domain/fundraising-draft.model';
import type { FundraisingFormError } from '../../_shared/domain/fundraising-form-error';

/**
 * Redux state for the Add-fundraising form: the editable draft, the save
 * lifecycle, per-field validation messages, and the last business error.
 * Every field is serialisable.
 */
export interface AddFundraisingState {
  draft: FundraisingDraft;
  saveStatus: SaveStatus;
  validationErrors: ValidationErrors;
  error: FundraisingFormError | null;
  /** The round the last save created; what "Undo" removes. */
  created: FundraisingResponse | null;
}

/**
 * Factory (not a const): the pristine draft defaults to the CURRENT month and
 * year (legacy behaviour), so it must be computed when the form opens, not
 * once at module load.
 */
export function makeInitialState(): AddFundraisingState {
  return {
    draft: makeEmptyDraft(),
    saveStatus: 'idle',
    validationErrors: {},
    error: null,
    created: null,
  };
}
